import apiHeader from "@/helpers/apiHeader";

const sapConnectionService = {
  list(params) {
    return apiHeader.get("sap/sap-connection", { params });
  },
  get(id) {
    return apiHeader.get("sap/sap-connection/" + id);
  },
  create(params) {
    return apiHeader.post("sap/sap-connection", params); // POST untuk membuat koneksi SAP
  },
  update(code, params) {
    return apiHeader.put(`sap/sap-connection/${code}`, params);
  },
  delete(code) {
    return apiHeader.delete(`sap/sap-connection/${code}`); // Menggunakan URL dengan parameter code
  },
  setDefault(code) {
    return apiHeader.patch(`sap/sap-connection/${code}/change-default`);
  },
};

export default sapConnectionService;
